import { render, staticRenderFns } from "./TeacherDetails.vue?vue&type=template&id=8640cdb8&scoped=true&"
import script from "./TeacherDetails.vue?vue&type=script&lang=js&"
export * from "./TeacherDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetails.vue?vue&type=style&index=0&id=8640cdb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8640cdb8",
  null
  
)

export default component.exports